import React, { Component } from "react"
import { TextField, Stepper, Step, StepLabel, RaisedButton, Toggle } from "material-ui"
import strings from "../../../../localization/strings"
import DropDownMenu, { MenuItem } from "../../../common/dropdownSelect/DropDownMenu"
import * as utils from "../../../../helpers/utils"
import * as api from "../../../../api"
import AppStateStore from "../../../../stores/AppStateStore"
import { IAccountRegistraionDTO } from "../../../../models"
import * as userActions from "../../../../actions/UserActions"

interface IProps {
    closeDrawer(): void
    reloadData(): void
}

interface IState {
    accountName: string
    accountNameErrorText: string
    userFirstName: string
    userFirstNameErrorText: string
    userLastName: string
    userLastNameErrorText: string
    userEmail: string
    userEmailErrorText: string
    activeStep: number
    totalSteps: number
    typeOfBusiness: number
    sizeOfBusiness: number
    sendUserWelcomeEmail: boolean
    saveValidate: boolean
}

export default class AccountManagerClientTabDrawerNewAccount extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            accountName: "",
            accountNameErrorText: "",
            userFirstName: "",
            userLastName: "",
            userEmail: "",
            activeStep: 0,
            totalSteps: 3,
            typeOfBusiness: 0,
            sizeOfBusiness: 0,
            sendUserWelcomeEmail: false,
            userFirstNameErrorText: "",
            userLastNameErrorText: "",
            userEmailErrorText: "",
            saveValidate: false,
        }
    }

    async addNewAccount() {
        var validate = await this.checkValidate(true)
        validate &&
            this.addNewAccountAPI()
    }

    addNewAccountAPI() {
        AppStateStore.setProgressSnackbarContent("Creating New Account")

        const accountRegistrationDTO = {
            AccountName: this.state.accountName,
            Email: this.state.userEmail,
            FirstName: this.state.userFirstName,
            LastName: this.state.userLastName,
            CompanyType: this.state.typeOfBusiness,
            CompanySize: this.state.sizeOfBusiness,
            SendWelcomeEmail: this.state.sendUserWelcomeEmail,
            RegistByAccountManager: true
        } as IAccountRegistraionDTO

        api.accountRegistration(accountRegistrationDTO).then(() => {
            AppStateStore.setProgressSnackbarContent("The account has been created.")
            this.props.closeDrawer()
            this.props.reloadData()

            this.setState({
                accountName: "",
                accountNameErrorText: "",
                userFirstName: "",
                userLastName: "",
                userEmail: "",
                activeStep: 0,
                totalSteps: 3,
                typeOfBusiness: 0,
                sizeOfBusiness: 0,
                sendUserWelcomeEmail: false,
                userFirstNameErrorText: "",
                userLastNameErrorText: "",
                userEmailErrorText: "",
                saveValidate: false,
            })
        }
        )
    }

    checkValidate(onSave) {
        if (!onSave && !this.state.saveValidate) return new Promise(fulfill => fulfill(true))

        this.setState({ saveValidate: true })
        let returnVal = true

        if (this.state.accountName.length === 0) {
            this.setState({ accountNameErrorText: "Account name cannot be empty." })
            returnVal = false
        } else {
            this.setState({ accountNameErrorText: "" })
        }

        if (this.state.userFirstName.length === 0) {
            this.setState({ userFirstNameErrorText: strings.First_Name_cannot_be_empty })
            returnVal = false
        } else {
            this.setState({ userFirstNameErrorText: "" })
        }

        if (this.state.userLastName.length === 0) {
            this.setState({ userLastNameErrorText: "Last name cannot be empty." })
            returnVal = false
        } else {
            this.setState({ userLastNameErrorText: "" })
        }

        if (utils.validateEmail(this.state.userEmail)) {
            this.setState({ userEmailErrorText: "" })
        } else {
            this.setState({ userEmailErrorText: strings.Invalid_email_format })
            returnVal = false
        }

        return userActions.emailExists(this.state.userEmail).then((result) => {
            if (result.data) {
                this.setState({ userEmailErrorText: strings.Email_already_in_use })
                returnVal = false
            }
            return returnVal
        })
    }

    handleTypeOfBusinessChange = (_event, _index, value) => {
        this.setState({ typeOfBusiness: value })
    }

    render() {
        return (
            <div>
                <div style={{ padding: 15, backgroundColor: AppStateStore.getFrontEndSettings().UISettings.AccentColor , height: 70 }}>
                    <h2 style={{ color: "#ffffff" }}>
                        {strings.Add_New_Account}
                        <i className="fa fa-close itemActionButton" style={{ float: "right" }} onClick={() => this.props.closeDrawer()} />
                    </h2>
                </div>
                <div style={{ padding: 30 }}>
                    <Stepper activeStep={this.state.activeStep} style={{ display: "none" }}>
                        <Step>
                            <StepLabel>Basic Information</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>Type of Company</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>Review and Create</StepLabel>
                        </Step>
                    </Stepper>

                    {this.state.activeStep === 0 &&
                        <div>
                            <TextField
                                autoFocus
                                floatingLabelText={strings.AccountName}
                                value={this.state.accountName}
                                errorText={this.state.accountNameErrorText}
                                onChange={(_e, value) => this.setState({ accountName: value }, () =>
                                    this.checkValidate(false)
                                )}
                                style={{ marginRight: 20, width: "100%" }}
                            />
                            <TextField
                                floatingLabelText={strings.AccountOwnerFirstName}
                                value={this.state.userFirstName}
                                onChange={(_e, value) => this.setState({ userFirstName: value }, () =>
                                    this.checkValidate(false)
                                )}
                                errorText={this.state.userFirstNameErrorText}
                                style={{ marginRight: 20, width: "100%" }}
                            />
                            <TextField
                                floatingLabelText={strings.AccountOwnerLastName}
                                value={this.state.userLastName}
                                onChange={(_e, value) => this.setState({ userLastName: value }, () =>
                                    this.checkValidate(false)
                                )}
                                errorText={this.state.userLastNameErrorText}
                                style={{ marginRight: 20, width: "100%" }}
                            />
                            <TextField
                                floatingLabelText={strings.AccountOwnerEmail}
                                value={this.state.userEmail}
                                autoComplete="off"
                                onChange={(_e, value) => this.setState({ userEmail: value }, () =>
                                    this.checkValidate(false)
                                )}
                                errorText={this.state.userEmailErrorText}
                                style={{ marginRight: 20, width: "100%" }}
                            />
                            <Toggle
                                toggled={this.state.sendUserWelcomeEmail}
                                onToggle={(_event, value) => this.setState({ sendUserWelcomeEmail: value })}
                                labelPosition="left"
                                label={strings.SendWelcomeEmail}
                                style={{ maxWidth: 450, marginBottom: 15 }}
                            />
                        </div>
                    }

                    <div style={{ marginTop: 50 }}>
                        <RaisedButton
                            data-intercom-target={"AccountManagerDrawer-Btn-save"}
                            label={strings.Create_new}
                            secondary
                            onTouchTap={() => this.addNewAccount()}
                        />
                    </div>

                    {this.state.activeStep === 1 &&
                        <div>
                            <h3>What type of business are you?</h3>
                            <DropDownMenu value={this.state.typeOfBusiness} onChange={this.handleTypeOfBusinessChange}>
                                <MenuItem value={0} primaryText={"Janitorial"} key={0} />
                                <MenuItem value={1} primaryText={"Security"} key={1} />
                                <MenuItem value={2} primaryText={"Construction"} key={2} />
                                <MenuItem value={3} primaryText={"Manufacturing"} key={3} />
                                <MenuItem value={3} primaryText={"Other"} key={4} />
                            </DropDownMenu>

                            <h3>How many employees do you have?</h3>
                            <DropDownMenu value={this.state.sizeOfBusiness} onChange={this.handleTypeOfBusinessChange}>
                                <MenuItem value={0} primaryText={"0-10"} key={0} />
                                <MenuItem value={1} primaryText={"10-50"} key={1} />
                                <MenuItem value={2} primaryText={"50-100"} key={2} />
                                <MenuItem value={3} primaryText={"100-500"} key={3} />
                                <MenuItem value={3} primaryText={"500+"} key={4} />
                            </DropDownMenu>
                        </div>
                    }

                    <div style={{ marginTop: 50, width: "100%", display: "none", }}>
                        {(this.state.activeStep > 0) &&
                            <div style={{ float: "left" }}>
                                <RaisedButton
                                    data-intercom-target={"AccountManagerDrawer-Btn-previous"}
                                    label={strings.Previous}
                                    secondary
                                    onTouchTap={() => this.setState({ activeStep: (this.state.activeStep - 1) })}
                                />
                            </div>
                        }
                        {(this.state.activeStep + 1) < this.state.totalSteps &&
                            <div style={{ float: "right" }}>
                                <RaisedButton
                                    data-intercom-target={"AccountManagerDrawer-Btn-next"}
                                    label={strings.Next}
                                    secondary
                                    onTouchTap={() => this.setState({ activeStep: (this.state.activeStep + 1) })}
                                />
                            </div>
                        }
                        <div style={{ clear: "both" }} />
                    </div>
                </div>
            </div>
        )
    }
}